<template>
  <div class="content design">
    <!-- <div id="slide"> -->
    <img :src="sidebarImage" class="sidebarImage" />
    <!-- </div> -->
    <h1>We design elegant and effective websites</h1>

    <div class="bambooWrapper">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 194 942"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g transform="matrix(1,0,0,1,-117.514,161.594)">
          <g transform="matrix(1,0,0,0.869632,-20.0423,403.638)">
            <path
              id="b1"
              class="stem"
              d="M159.748,239.835C168.086,239.493 164.919,238.663 169.177,237.338C171.089,236.742 178.934,234.713 180.476,235.707C186.059,239.308 184.942,245.851 181.056,250.335C176.797,255.25 176.429,261.199 175.937,267.746C175.384,275.123 174.067,293.825 173.695,301.269C172.521,324.745 172.323,346.494 171.258,370.032C170.692,382.536 173.589,400.013 173.493,412.363C173.448,418.18 176.081,422.362 172.619,427.928C171.489,429.745 165.302,428.854 163.6,428.854C155.559,428.854 148,432.792 140.012,432.178C136.71,431.924 137.269,427.309 138.613,425.158C144.717,415.391 142.719,403.316 144.355,392.053C147.634,369.475 151.105,333.001 152.125,310.214C152.543,300.882 151.168,272.851 150.282,265.418C149.437,258.331 147.012,255.283 146.223,248.268C145.907,245.462 149.069,239.54 149.833,239.211C150.709,238.832 153.005,239.837 154.316,240.225"
            />
          </g>
          <g transform="matrix(1,0,0,0.869632,-10.4277,229.591)">
            <path
              id="b2"
              class="stem"
              d="M158.208,240.095C166.546,239.752 164.919,238.663 169.177,237.338C171.089,236.742 179.382,234.234 180.476,235.707C183.387,239.628 180.895,247.911 180.184,252.014C179.072,258.421 176.429,261.199 175.937,267.746C175.384,275.123 174.067,293.825 173.695,301.269C172.521,324.745 171.497,339.741 170.433,363.279C169.867,375.783 168.047,391.915 167.951,404.266C167.906,410.082 176.081,422.362 172.619,427.928C171.489,429.745 165.302,428.854 163.6,428.854C155.559,428.854 148,432.792 140.012,432.178C136.71,431.924 137.269,427.309 138.613,425.158C144.717,415.391 141.592,399.025 143.228,387.761C146.507,365.183 147.248,339.855 148.268,317.068C148.686,307.736 151.168,272.851 150.282,265.418C149.437,258.331 147.012,255.283 146.223,248.268C145.907,245.462 148.85,242.696 149.614,242.366C150.49,241.988 153.005,239.837 154.316,240.225"
            />
          </g>
          <g transform="matrix(1,0,0,1,-1.16797,0.548828)">
            <path
              id="b3"
              class="stem"
              d="M155.386,238.752C164.952,238.962 167.377,239.262 172.896,238.621C174.281,238.46 179.137,236.858 180.23,238.33C183.142,242.252 180.895,247.911 180.184,252.014C179.072,258.421 175.932,264.625 175.441,271.172C174.888,278.549 172.64,285.793 172.268,293.236C171.094,316.713 168.073,340.089 167.008,363.627C166.442,376.131 164.721,392.094 167.951,404.266C169.428,409.829 176.081,422.362 172.619,427.928C171.489,429.745 165.302,428.854 163.6,428.854C155.559,428.854 148,432.792 140.012,432.178C136.71,431.924 137.269,427.309 138.613,425.158C144.717,415.391 144.569,399.701 146.205,388.438C149.484,365.859 149.75,341.852 150.77,319.064C151.188,309.733 152.857,298.913 151.938,290.568C151.125,283.178 151.708,276.404 150.822,268.971C149.978,261.884 147.012,255.283 146.223,248.268C145.907,245.462 144.913,242.206 145.582,239.402C145.821,238.4 147.02,237.304 147.784,236.975C148.66,236.596 150.245,236.864 151.556,237.252"
            />
          </g>
          <g transform="matrix(1,0,0,1,7.61663,-197.688)">
            <path
              id="b4"
              class="stem"
              d="M155.386,238.752C164.952,238.962 167.377,239.262 172.896,238.621C174.281,238.46 179.137,236.858 180.23,238.33C183.142,242.252 180.895,247.911 180.184,252.014C179.072,258.421 175.932,264.625 175.441,271.172C174.888,278.549 172.64,285.793 172.268,293.236C171.094,316.713 168.073,340.089 167.008,363.627C166.442,376.131 164.721,392.094 167.951,404.266C169.428,409.829 176.081,422.362 172.619,427.928C171.489,429.745 164.631,432.497 162.929,432.497C154.888,432.497 148.47,431.905 140.482,431.29C137.18,431.037 138.751,423.599 140.095,421.448C146.2,411.682 144.569,399.701 146.205,388.438C149.484,365.859 149.75,341.852 150.77,319.064C151.188,309.733 152.857,298.913 151.938,290.568C151.125,283.178 151.708,276.404 150.822,268.971C149.978,261.884 147.012,255.283 146.223,248.268C145.907,245.462 144.913,242.206 145.582,239.402C145.821,238.4 147.02,237.304 147.784,236.975C148.66,236.596 150.245,236.864 151.556,237.252"
            />
          </g>

          <g serif:id="b5" transform="matrix(1,0,0,1,15.6628,-398.386)">
            <path
              id="b5"
              class="stem"
              d="M155.386,238.752C164.952,238.962 167.377,239.262 172.896,238.621C174.281,238.46 179.137,236.858 180.23,238.33C183.142,242.252 180.895,247.911 180.184,252.014C179.072,258.421 175.932,264.625 175.441,271.172C174.888,278.549 172.64,285.793 172.268,293.236C171.094,316.713 168.073,340.089 167.008,363.627C166.442,376.131 164.721,392.094 167.951,404.266C169.428,409.829 175.634,425.699 172.173,431.265C171.042,433.082 164.315,433.686 162.613,433.686C154.572,433.686 148,432.792 140.012,432.178C136.71,431.924 137.269,427.309 138.613,425.158C144.717,415.391 144.569,399.701 146.205,388.438C149.484,365.859 149.75,341.852 150.77,319.064C151.188,309.733 152.857,298.913 151.938,290.568C151.125,283.178 151.708,276.404 150.822,268.971C149.978,261.884 147.012,255.283 146.223,248.268C145.907,245.462 144.913,242.206 145.582,239.402C145.821,238.4 147.02,237.304 147.784,236.975C148.66,236.596 150.245,236.864 151.556,237.252"
            />
          </g>

          <path
            id="s1"
            class="stemSmall"
            d="M163.59,591.778C167.337,583.816 172.747,575.237 177.339,567.774C182.731,559.011 186.107,553.344 193.326,545.642C197.515,541.173 201.309,536.598 205.476,532.097C206.927,530.531 208.468,529.602 209.786,527.938C210.43,527.127 213.567,525.088 212.83,525.816C200.502,537.991 187.964,550.676 177.793,572.396C174.627,579.156 171.633,586.45 168.256,593.095C167.729,594.13 166.285,599.162 165,599.566C162.679,600.294 162.865,595.545 162.865,594.269"
          />
          <g transform="matrix(-0.989394,0.145254,0.145254,0.989394,774.185,87.5631)">
            <path
              id="l1"
              class="leaf"
              d="M615.42,349.404C615.132,349.404 613.312,347.03 612.795,346.704C608.27,343.845 603.954,339.927 598.954,338.131C597.082,337.458 593.05,338.396 591.031,338.577C587.09,338.932 583.011,338.426 579.049,338.558C567.9,338.928 556.704,337.602 545.579,337.602C541.434,337.602 537.233,337.317 533.093,337.523C532.355,337.559 530.148,336.925 529.644,337.373C529.61,337.403 531.659,338.267 531.824,338.321C533.385,338.827 535.005,339.159 536.586,339.601C540.803,340.778 545.268,342.034 549.562,342.853C555.346,343.957 560.841,345.973 566.591,347.118C576.65,349.121 587.116,349.771 597.333,350.653C601.58,351.02 606.771,351.651 611.03,350.783C612.083,350.568 613.475,350.186 614.121,350.342"
            />
          </g>
          <g transform="matrix(-1,0,0,1,845.135,170.284)">
            <path
              id="l2"
              class="leaf"
              d="M628.959,358.037C623.665,358.037 615.843,353.831 610.633,355.653C582.937,365.338 562.961,371.859 566.222,370.725C568.548,369.916 533.481,386.273 533.923,386.345C543.759,387.944 555.471,380.472 564.86,378.575C569.213,377.695 573.65,376.2 578.053,375.692C587.978,374.547 597.893,374.468 607.807,373.034C614.082,372.127 619.19,368.728 623.211,364.131C624.554,362.594 625.855,361.026 627.289,359.573C627.914,358.94 628.994,356.63 628.994,357.52"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="bambooWrapper2">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 194 942"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g transform="matrix(1,0,0,1,-117.514,161.594)">
          <g transform="matrix(1,0,0,0.869632,-20.0423,403.638)">
            <path
              id="b2b1"
              class="b2stem"
              d="M159.748,239.835C168.086,239.493 164.919,238.663 169.177,237.338C171.089,236.742 178.934,234.713 180.476,235.707C186.059,239.308 184.942,245.851 181.056,250.335C176.797,255.25 176.429,261.199 175.937,267.746C175.384,275.123 174.067,293.825 173.695,301.269C172.521,324.745 172.323,346.494 171.258,370.032C170.692,382.536 173.589,400.013 173.493,412.363C173.448,418.18 176.081,422.362 172.619,427.928C171.489,429.745 165.302,428.854 163.6,428.854C155.559,428.854 148,432.792 140.012,432.178C136.71,431.924 137.269,427.309 138.613,425.158C144.717,415.391 142.719,403.316 144.355,392.053C147.634,369.475 151.105,333.001 152.125,310.214C152.543,300.882 151.168,272.851 150.282,265.418C149.437,258.331 147.012,255.283 146.223,248.268C145.907,245.462 149.069,239.54 149.833,239.211C150.709,238.832 153.005,239.837 154.316,240.225"
            />
          </g>
          <g transform="matrix(1,0,0,0.869632,-10.4277,229.591)">
            <path
              id="b2b2"
              class="b2stem"
              d="M158.208,240.095C166.546,239.752 164.919,238.663 169.177,237.338C171.089,236.742 179.382,234.234 180.476,235.707C183.387,239.628 180.895,247.911 180.184,252.014C179.072,258.421 176.429,261.199 175.937,267.746C175.384,275.123 174.067,293.825 173.695,301.269C172.521,324.745 171.497,339.741 170.433,363.279C169.867,375.783 168.047,391.915 167.951,404.266C167.906,410.082 176.081,422.362 172.619,427.928C171.489,429.745 165.302,428.854 163.6,428.854C155.559,428.854 148,432.792 140.012,432.178C136.71,431.924 137.269,427.309 138.613,425.158C144.717,415.391 141.592,399.025 143.228,387.761C146.507,365.183 147.248,339.855 148.268,317.068C148.686,307.736 151.168,272.851 150.282,265.418C149.437,258.331 147.012,255.283 146.223,248.268C145.907,245.462 148.85,242.696 149.614,242.366C150.49,241.988 153.005,239.837 154.316,240.225"
            />
          </g>
          <g transform="matrix(1,0,0,1,-1.16797,0.548828)">
            <path
              id="b2b3"
              class="b2stem"
              d="M155.386,238.752C164.952,238.962 167.377,239.262 172.896,238.621C174.281,238.46 179.137,236.858 180.23,238.33C183.142,242.252 180.895,247.911 180.184,252.014C179.072,258.421 175.932,264.625 175.441,271.172C174.888,278.549 172.64,285.793 172.268,293.236C171.094,316.713 168.073,340.089 167.008,363.627C166.442,376.131 164.721,392.094 167.951,404.266C169.428,409.829 176.081,422.362 172.619,427.928C171.489,429.745 165.302,428.854 163.6,428.854C155.559,428.854 148,432.792 140.012,432.178C136.71,431.924 137.269,427.309 138.613,425.158C144.717,415.391 144.569,399.701 146.205,388.438C149.484,365.859 149.75,341.852 150.77,319.064C151.188,309.733 152.857,298.913 151.938,290.568C151.125,283.178 151.708,276.404 150.822,268.971C149.978,261.884 147.012,255.283 146.223,248.268C145.907,245.462 144.913,242.206 145.582,239.402C145.821,238.4 147.02,237.304 147.784,236.975C148.66,236.596 150.245,236.864 151.556,237.252"
            />
          </g>
          <g transform="matrix(1,0,0,1,7.61663,-197.688)">
            <path
              id="b2b4"
              class="b2stem"
              d="M155.386,238.752C164.952,238.962 167.377,239.262 172.896,238.621C174.281,238.46 179.137,236.858 180.23,238.33C183.142,242.252 180.895,247.911 180.184,252.014C179.072,258.421 175.932,264.625 175.441,271.172C174.888,278.549 172.64,285.793 172.268,293.236C171.094,316.713 168.073,340.089 167.008,363.627C166.442,376.131 164.721,392.094 167.951,404.266C169.428,409.829 176.081,422.362 172.619,427.928C171.489,429.745 164.631,432.497 162.929,432.497C154.888,432.497 148.47,431.905 140.482,431.29C137.18,431.037 138.751,423.599 140.095,421.448C146.2,411.682 144.569,399.701 146.205,388.438C149.484,365.859 149.75,341.852 150.77,319.064C151.188,309.733 152.857,298.913 151.938,290.568C151.125,283.178 151.708,276.404 150.822,268.971C149.978,261.884 147.012,255.283 146.223,248.268C145.907,245.462 144.913,242.206 145.582,239.402C145.821,238.4 147.02,237.304 147.784,236.975C148.66,236.596 150.245,236.864 151.556,237.252"
            />
          </g>

          <g serif:id="b5" transform="matrix(1,0,0,1,15.6628,-398.386)">
            <path
              id="b2b5"
              class="b2stem"
              d="M155.386,238.752C164.952,238.962 167.377,239.262 172.896,238.621C174.281,238.46 179.137,236.858 180.23,238.33C183.142,242.252 180.895,247.911 180.184,252.014C179.072,258.421 175.932,264.625 175.441,271.172C174.888,278.549 172.64,285.793 172.268,293.236C171.094,316.713 168.073,340.089 167.008,363.627C166.442,376.131 164.721,392.094 167.951,404.266C169.428,409.829 175.634,425.699 172.173,431.265C171.042,433.082 164.315,433.686 162.613,433.686C154.572,433.686 148,432.792 140.012,432.178C136.71,431.924 137.269,427.309 138.613,425.158C144.717,415.391 144.569,399.701 146.205,388.438C149.484,365.859 149.75,341.852 150.77,319.064C151.188,309.733 152.857,298.913 151.938,290.568C151.125,283.178 151.708,276.404 150.822,268.971C149.978,261.884 147.012,255.283 146.223,248.268C145.907,245.462 144.913,242.206 145.582,239.402C145.821,238.4 147.02,237.304 147.784,236.975C148.66,236.596 150.245,236.864 151.556,237.252"
            />
          </g>

          <path
            id="b2s1"
            class="b2stemSmall"
            d="M163.59,591.778C167.337,583.816 172.747,575.237 177.339,567.774C182.731,559.011 186.107,553.344 193.326,545.642C197.515,541.173 201.309,536.598 205.476,532.097C206.927,530.531 208.468,529.602 209.786,527.938C210.43,527.127 213.567,525.088 212.83,525.816C200.502,537.991 187.964,550.676 177.793,572.396C174.627,579.156 171.633,586.45 168.256,593.095C167.729,594.13 166.285,599.162 165,599.566C162.679,600.294 162.865,595.545 162.865,594.269"
          />
          <g transform="matrix(-0.989394,0.145254,0.145254,0.989394,774.185,87.5631)">
            <path
              id="b2l1"
              class="b2leaf"
              d="M615.42,349.404C615.132,349.404 613.312,347.03 612.795,346.704C608.27,343.845 603.954,339.927 598.954,338.131C597.082,337.458 593.05,338.396 591.031,338.577C587.09,338.932 583.011,338.426 579.049,338.558C567.9,338.928 556.704,337.602 545.579,337.602C541.434,337.602 537.233,337.317 533.093,337.523C532.355,337.559 530.148,336.925 529.644,337.373C529.61,337.403 531.659,338.267 531.824,338.321C533.385,338.827 535.005,339.159 536.586,339.601C540.803,340.778 545.268,342.034 549.562,342.853C555.346,343.957 560.841,345.973 566.591,347.118C576.65,349.121 587.116,349.771 597.333,350.653C601.58,351.02 606.771,351.651 611.03,350.783C612.083,350.568 613.475,350.186 614.121,350.342"
            />
          </g>
          <g transform="matrix(-1,0,0,1,845.135,170.284)">
            <path
              id="b2l2"
              class="b2leaf"
              d="M628.959,358.037C623.665,358.037 615.843,353.831 610.633,355.653C582.937,365.338 562.961,371.859 566.222,370.725C568.548,369.916 533.481,386.273 533.923,386.345C543.759,387.944 555.471,380.472 564.86,378.575C569.213,377.695 573.65,376.2 578.053,375.692C587.978,374.547 597.893,374.468 607.807,373.034C614.082,372.127 619.19,368.728 623.211,364.131C624.554,362.594 625.855,361.026 627.289,359.573C627.914,358.94 628.994,356.63 628.994,357.52"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="article">
      <H4>Web Site Design</H4>

      <p>We design websites that look great and are easy to use. Although internet applications are often incredibly complex, we believe that a well designed website is simple, attractive and intuitive.</p>

      <p>Bamboodev has been designing web sites for over 25 years. During this time the internet has evolved considerably, and websites have become far more than static images and text. However, one thing hasn't changed: effective design makes a website marketable, easy to use, and ultimately successful.</p>

      <p>Our clients range from revolutionary startups to well known household brands. Every client has a unique audience, and during our design process we work closely with our clients to develop a visual design that is perfectly suited for their audience.</p>

      <p>
        <img :src="images[2].image" class="inline" @click="zoomIn(images[2].image)" />
      </p>

      <H4>Logo Design and Brand Identity</H4>

      <p>A key element of design is the logo. By combining symbols, text and images into a recognizable mark, the logo communicates the very essence of a companies brand. From creative and playful, to abstract, minimal or corporate, the logo is responsible for representing a company and it's values via a single creative element. Needless to say, logo design is a challenging and critical task.</p>

      <p>Our logo design process involves working with our clients to identify their values and ideas. We discuss how the logo will be used, where it will be seen, and how it should be perceived. We then create a range of design candidates, which are then refined until we have a winning selection.</p>

      <p style="margin: 60px 0px;">
        <img
          :src="images[3].image"
          class="inline"
          style="max-width: 260px; margin: 0 auto; display: block;"
        />
        <!-- <span class="imageCaption">{{ images[3].title }}</span> -->
      </p>

      <H4>Interface Design</H4>

      <p>Many of our clients sell their products and services online. They've hired us to design and develop a website that makes online sales possible. It's a simple concept: show something for sale, and then accept payment. But in reality, there is much more to consider. How does the customer find the product they want? Where do they click to add the item to their shopping cart? What do they need to do to easily and securely provide their payment details?</p>

      <p>Careful interface design combines psychology, artistry and engineering to convert a complex challenge into an intuitive and simple task. By studying how customers use a website, we are able to fine tune their interactions. How many clicks are needed to add an item to a shopping cart? Can we make it easier? Are users able to navigate quickly, or is there an obstacle that results in frustration and lost opportunities? Interface design is the answer, and it plays a critical role in our workflow.</p>

      <p>
        <img :src="images[4].image" class="inline" @click="zoomIn(images[4].image)" />
      </p>

      <H4>Application Architecture</H4>

      <p>Modern web design requires making decisions far more involved than what is "seen" by end users. What language will the site be developed with? What kind of database? Will it make use of an API, or share data with other applications? These decisions will have far reaching implications, and will often determine the direction your business takes well into the future.</p>

      <p>We love a flexible architecture, because we know that the needs of our clients and their audience will evolve and change with time. No matter how large or small your business is now, we design and develop our applications in a way that makes it incredibly easy to scale and add new functionality.</p>

      <p>
        <router-link to="/development">Learn more about our development process</router-link>
      </p>

      <!-- <img :src="images[2].image" class="inlineImage imageIntersect" />
      <p>{{images[0].title}}</p>-->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// @ is an alias to /src
import { gsap } from "gsap";
// import VueEasyLightbox from "vue-easy-lightbox";
export default {
  name: "Design",
  components: {
    // VueEasyLightbox
  },
  data: () => ({
    observer: null,
    intersected: false,
    sidebarImage: "",
    images: [
      { title: "D1 Dashboard", icon: require("@/assets/d1.jpg") },
      { title: "D1 Dashboard", icon: require("@/assets/d1.jpg") },
      {
        title: "Gillian Toboni",
        image: require("@/assets/portfolio/gilliantoboni.com.jpg")
      },
      {
        title: "Logo Design Candidates",
        image: require("@/assets/portfolio/momentum_logos.png")
      },
      {
        title: "user experience and interface design",
        image: require("@/assets/portfolio/user-experience-interface-design.jpg")
      }
    ],
    imgs: "", // Img Url , string or Array
    visible: false,
    index: 0 // default
  }),
  methods: {
    zoomIn(url) {
      this.$root.images = url;
      this.$root.isVisible = true;
    },
    goFuck() {
      // console.log("yikes");
      // console.log(this.$root.isVisible);
      this.$root.images = "http://via.placeholder.com/150x150";
      this.$root.isVisible = true;
      // console.log(this.$root.isVisible);
    },
    goFuck2() {
      this.$root.images = "http://via.placeholder.com/550x150";
      this.$root.isVisible = true;
    },
    goFuck3() {
      this.$root.images = [
        "http://via.placeholder.com/100x100",
        "http://via.placeholder.com/200x200",
        "http://via.placeholder.com/300x300"
      ];
      this.$root.isVisible = true;
    }
    //   showSingle() {
    //     this.imgs = "http://via.placeholder.com/350x150";
    //     this.show();
    //   },
    //   showMultiple() {
    //     this.imgs = [
    //       "http://via.placeholder.com/350x150",
    //       "http://via.placeholder.com/350x150"
    //     ];
    //     this.index = 1; // index of imgList
    //     this.show();
    //   },
    //   show() {
    //     this.visible = true;
    //   },
    //   handleHide() {
    //     this.visible = false;
    //   }
  },
  mounted: function() {
    // pass images which will appear in article to the root lightbox:
    // this.$root.images = "some design images";

    // dev
    // console.log(this.$parent.$options.methods);

    let img = document.getElementsByClassName("sidebarImage");
    this.observer = new IntersectionObserver(entries => {
      // console.log(entries);
      const target = entries[0];
      if (target.isIntersecting) {
        // console.log(target);
        this.intersected = true;
        this.sidebarImage = target.target.src;
        img[0].classList.add("fadeIn");
      } else {
        img[0].classList.remove("fadeIn");
      }
    });

    // targets to observe:
    let images = document.getElementsByClassName("imageIntersect");
    images.forEach(image => {
      // this.observer.observe(image);
    });

    // bamboo animation
    var tl = new gsap.timeline();

    // DRAW BAMBOO 1
    // grow major stems
    let stem = document.getElementsByClassName("stem");
    tl.staggerFrom(
      stem,
      1,
      {
        delay: 0,
        duration: 0.5,
        scale: 0.02,
        y: 200,
        rotate: 0,
        opacity: 0
      },
      0.3
    );

    // DRAW BAMBOO 2
    // grow major stems
    let b2stem = document.getElementsByClassName("b2stem");
    tl.staggerFrom(
      b2stem,
      1,
      {
        delay: -2,
        duration: 0.5,
        scale: 0.02,
        y: 200,
        rotate: 0,
        opacity: 0
      },
      0.3
    );

    // grow minor stem
    let stemSmall = document.getElementsByClassName("stemSmall");
    tl.from([stemSmall], 1, {
      // delay: 2,
      scale: 0.01,
      rotate: 0,
      y: 100,
      opacity: 0
    });

    // grow leaves
    let leaf1 = document.getElementById("l1");
    tl.from(leaf1, 1, {
      scale: 0.01,
      y: 10,
      x: 90,
      opacity: 0
    });
    let leaf2 = document.getElementById("l2");
    tl.from(leaf2, 1, {
      scale: 0.01,
      y: 10,
      x: 90,
      opacity: 0
    });

    // // DRAW BAMBOO 2
    // grow minor stem
    let b2stemSmall = document.getElementsByClassName("b2stemSmall");
    tl.from([b2stemSmall], 1, {
      // delay: -2,
      scale: 0.01,
      rotate: 0,
      y: 100
    });

    // grow leaves
    let b2leaf1 = document.getElementById("b2l1");
    tl.from(b2leaf1, 1, {
      // delay: -2,
      scale: 0.01,
      y: 10,
      x: 90
    });
    let b2leaf2 = document.getElementById("b2l2");
    tl.from(b2leaf2, 1, {
      // delay: -2,
      scale: 0.01,
      y: 10,
      x: 90
    });

    // end animation
  },
  beforeDestroy: function() {
    this.observer.disconnect();
  }
};
</script>

<style lang="scss">
.design {
  .inline {
    width: 100%;
    height: auto;
    cursor: pointer;
    // &:hover {
    //   border: 2px solid #42b983;
    // }
  }
  .inlineImage {
    width: 100%;
    height: auto;
    height: 0px;
    width: 0px;
  }
  .sidebarImage {
    position: fixed;
    width: 40vw;
    height: auto;
    left: 0px;
    top: 40%;
    margin-left: 50px;
    opacity: 0;
    transition: all 0.5s ease-in;
  }
  .fadeIn {
    opacity: 1;
    margin-left: 60px;
  }
  overflow: hidden;
  svg {
    display: block;
    width: auto;
    height: 110vh;
    overflow: hidden;
    fill: rgba(255, 255, 255, 0.3);
  }
  .bambooWrapper {
    transition: opacity 0.5s ease;
    height: 120vh;
    position: fixed;
    left: 300px;
    top: -10px;
    z-index: 1;
  }
  .bambooWrapper2 {
    transition: opacity 0.5s ease;
    height: 220vh;
    transform: rotate(-1deg) scaleX(-1);
    position: fixed;
    left: -100px;
    bottom: -22vh;
    z-index: 1;
    svg {
      height: 200vh;
      fill: rgba(255, 255, 255, 0.1);
    }
  }
  .hidden {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .design.content {
    padding-top: 100px;
    display: block;
    padding-top: 60vh;

    h1 {
      display: inline;
      bottom: inherit;
      left: inherit;
      position: unset;
      width: 100%;
      z-index: 100;
    }
    .article {
      display: block;
      width: 90vw;
      padding: 0px 30px;
      // top: 90vh;
      margin-top: 0px;
      // position: relative;
      // z-index: 50;
    }
  }
}
</style>
